/* eslint-disable ssr-friendly/no-dom-globals-in-react-fc */

// ink-component
import React, { ReactNode } from 'react';

import { ThemeProvider } from 'styled-components';
import { MessageScrollWrapper } from '../../styles';

import getGlobalProps from '../../../../helpers/constants/global-props';
import { CSSHeightType } from '../../../../helpers/constants/cssPropTypes';

export interface MessageScrollerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Callback for the click event */
  height?: CSSHeightType;
  /** Message content */
  children: ReactNode;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Message fold to expand or collapse previous messages
 * @group Message
 */
const MessageScroller: React.FC<MessageScrollerProps> = ({
  className,
  style,
  height,
  children,
  'data-testid': dataTestId,
  ...otherProps
}) => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (scrollRef.current && containerRef.current) {
      const container = containerRef.current;
      const scrollElement = scrollRef.current;

      // Check if the scrollRef element is at the bottom of the container
      const isAtBottom = scrollElement.offsetTop >= container.scrollTop + container.clientHeight;

      if (isAtBottom) {
        container.scrollTo({
          top: container.scrollHeight,
        });
      }
    }
  }, []);

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        messageScrollerHeight: height,
      })}
    >
      <MessageScrollWrapper ref={containerRef} {...globalProps} {...otherProps} data-testid={dataTestId}>
        {children}
        <div ref={scrollRef} />
      </MessageScrollWrapper>
    </ThemeProvider>
  );
};

MessageScroller.defaultProps = {};

MessageScroller.displayName = 'MessageScroller';

export default MessageScroller;
